export default (name) =>
  name
    ? name
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .replace(/([^\w ]|_)/g, '')
        .replace(/\s+/g, '-')
        .toLowerCase()
    : '';
